import { useSearchParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { buttonStyle} from '../libs/sharedStyles.js';
import { primaryButtonClasses, secondaryButtonClasses } from '../libs/sharedClassNames.js';
import { useAuthContext } from '../contexts/AuthContext.jsx';

export default function ConfirmIntent() {
  const [searchParams] = useSearchParams();
  const [confirmationUrl, setConfirmationUrl] = useState(null);
  const [error, setError] = useState('');
  const { user } = useAuthContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/home');
    }
  }, [user]);

  useEffect(() => {
    const rawUrl = searchParams.get('confirmationUrl');

    if (!rawUrl) {
      setError('Missing confirmation URL.');
      return;
    }

    try {
      const url = new URL(rawUrl);
      if (url.protocol !== 'https:') {
        setError('Invalid confirmation URL: must use HTTPS.');
      } else {
        setConfirmationUrl(rawUrl);
      }
    } catch (e) {
      setError('Malformed confirmation URL.');
    }
  }, [searchParams]);

  const handleClick = () => {
    if (confirmationUrl) {
      window.location.href = confirmationUrl;
    }
  };

  return (
    <div className="mx-auto max-w-2xl mt-20 px-4 text-center">
      <h2 className="text-2xl font-bold mb-4">Confirm Sign In</h2>
      <p className="text-gray-700 mb-6">
        Some email providers open confirmation links automatically, which can invalidate them. To proceed, please click the button below manually.
      </p>

      {error && (
        <div className="text-red-600 font-medium mb-4">
          {error}
        </div>
      )}

      <button
        onClick={handleClick}
        disabled={!confirmationUrl}
        style={buttonStyle}
        className={primaryButtonClasses}
      >
        Confirm and Continue
      </button>
    </div>
  );
}
